export class Outcome {
    outcomeId: number;
    title: string;
    level: string;
    credits: number;
    learningOutcomes: string;
    assessmentCriteria: string;
    unitPurpose: string;
    expiryDate: Date;
    timeStamp: Date;
    active: boolean;
    expanded: boolean;
    inScene: boolean;
    customerId: number;
    isGroup: boolean;
    checked: boolean;
    outcomeGroupId: number;
}